export default "__VITE_ASSET__TYKX_hFS__"